// consoles/ems/langContext.js —— 能源管家语言上下文（中 / 英）
// 不引入第三方 i18n 库：lang 状态由 EmsConsole 持有，经 LangContext 下发；
// 各面板组件用 useLang() 取 lang，文案用 t(lang, zh, en) 包装。
// t 三参：lang==='en' 时返回 en；缺省 en 时回退 DICT 内置词典（覆盖设备状态等数据词）；仍查不到则返回中文原文。
import { createContext, useContext } from 'react';

export const LangContext = createContext({ lang: 'zh', setLang: () => {} });

// 数据词词典：设备状态 / 节点类型 / 时段类型等来自 config 或 data 的值，展示时经 t(lang, v) 转英文
const DICT = {
  '正常': 'Normal', '运行': 'Running', '停机': 'Stopped', '中断': 'Interrupted',
  '告警': 'Alarm', '在线': 'Online', '离线': 'Offline', '故障': 'Fault', '延迟': 'Delay',
  '就绪': 'Ready', '禁放': 'Discharge Blocked', '待机': 'Standby',
  '已启用': 'Enabled', '未启用': 'Disabled', '已恢复': 'Recovered',
  '成功': 'Success', '失败': 'Failed', '充电': 'Charging', '放电': 'Discharging',
  '无告警': 'No Alarm', '闭合': 'Closed',
  '尖': 'Sharp', '峰': 'Peak', '平': 'Flat', '谷': 'Valley', '深谷': 'Deep Valley', '不计费': 'Free',
  '储能节点': 'Storage Node', '变压器节点': 'Transformer Node', '光伏节点': 'PV Node',
  '负载节点': 'Load Node', '公共连接点': 'PCC', '双向电表': 'Bi-directional Meter',
  'BMS电池堆': 'BMS Battery Pack', '空调': 'AC Unit', '电表': 'Meter', '消防': 'Fire',
  '液冷机组': 'Liquid Cooling Unit', '消防主机': 'Fire Host', '温湿度计': 'TH Sensor',
  '水浸': 'Water Sensor', '烟感': 'Smoke Sensor',
};

export function t(lang, zh, en) {
  if (lang !== 'en') return zh;
  if (en) return en;
  return DICT[zh] || zh;
}

export function useLang() {
  return useContext(LangContext);
}
